var _rect, _text, _circle, _circle2, _circle3, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 600,
    viewBox: "0 0 800 600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 600,
    fill: "#f0f0f0"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 300,
    fontFamily: "Arial",
    fontSize: 24,
    fill: "#666",
    textAnchor: "middle"
  }, "\r\n        Imagem da Equipe em A\xE7\xE3o\r\n    ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 50,
    fill: "#4a90e2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 200,
    r: 50,
    fill: "#4a90e2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 200,
    r: 50,
    fill: "#4a90e2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 250,
    y1: 200,
    x2: 350,
    y2: 200,
    stroke: "#4a90e2",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 450,
    y1: 200,
    x2: 550,
    y2: 200,
    stroke: "#4a90e2",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamAction);
export default __webpack_public_path__ + "static/media/team-action.9bc419b3655c65ff0dd3b0ad3610ffdf.svg";
export { ForwardRef as ReactComponent };